import { handleApiError, IErrorHandlers } from "@/utils/handleErrors";
import useSnackbarErrors from "./useSnackbarErrors";

export default function useHandleApiErrors(errorHandlers?: IErrorHandlers) {
  const { setSnackbarErrorMessage } = useSnackbarErrors();

  return (error: unknown) =>
    handleApiError({ error, errorHandlers, setSnackbarErrorMessage });
}
